import  { useState,useEffect, useRef } from 'react';
/* CSS */
import '../styles/stepper.css'
import BackdropModal from './modals/backdrop_modal';
import SignatureModal from './SignatureModal';

/* 3RD PARTY */
import Tooltip from '@mui/material/Tooltip';


const ImageCaptureMinimal = ({ onImageChange, title="Capture an Image", subtitle="", btnCameraTitle="Open Camera", keyName="captured-image",preLoadedImage, useSignaturePad=true, hasUploadButton=true, hasRemoveButton=false }) => {
    
    const [cameras, setCameras] = useState([]); // Store available cameras
    const [selectedCamera, setSelectedCamera] = useState(null); // Store selected camera
    const [isModalOpen, setModalOpen] = useState(false);
    
     


    // GET ALL CAMERAS
    useEffect(() => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
                setCameras(videoDevices);
            })
            .catch(error => {
                console.error('Error accessing media devices:', error);
            });
    }, []);
    
    const [isFromURL,setIsfromUrl] = useState(false);
    useEffect(() => {
        if (preLoadedImage) {
            if (typeof preLoadedImage === "string") {
                // It's a URL
                setPreview(preLoadedImage); // Directly use the URL as preview
                setImage(preLoadedImage);   // Set the URL as the image
                setImageName("Captured Image"); // Optionally, set a default name
                setIsfromUrl(true);
            } else if (preLoadedImage instanceof File) {
                // It's a File object
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result); // Set the data URL as preview
                    setImage(preLoadedImage);
                    setImageName(preLoadedImage.name || "Captured Image");
                };
                reader.readAsDataURL(preLoadedImage); // Convert the file to a data URL
                setIsfromUrl(false);
            }
        }
    }, [preLoadedImage]);
    

    const [image, setImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const [preview, setPreview] = useState(preLoadedImage);
    const [isCameraOpen, setIsCameraOpen] = useState(false);
    const [showOpenCameraButton, setShowOpenCameraButton] = useState(true);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const fileInputRef = useRef(null);

  const [isAnimating, setIsAnimating] = useState(false);
  const playClickSound = () => {
    const clickSound = new Audio('/iusevolutione/assets/audio/camera_shutter.mp3'); // Provide path to your click sound
    clickSound.play();
  };


    const handleFileChange = (e) => {
        if (e && e.target && e.target.files && e.target.files.length > 0) {

            console.log(e);

            const file = e.target.files[0];
            setImage(file);
            setImageName(file.name);
            const fileReader = new FileReader();
            fileReader.onload = () => {
                setPreview(fileReader.result);
            };
            fileReader.readAsDataURL(file);
            setIsCameraOpen(false);
            setShowOpenCameraButton(false);

            onImageChange(file,keyName); // Notify parent component of the selected file
        }
        else {
            return
        }
    };

    const openCamera = () => {
        setIsCameraOpen(true);
        setPreview(null);
        setImageName("");
        setShowOpenCameraButton(false);

       /* navigator.mediaDevices.getUserMedia({ video: { width: 275, height: 275 } })
            .then(stream => {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
            })
            .catch(err => {
                console.error("Error accessing camera: ", err);
            });*/

            if(cameras.length > 0){
                if (!selectedCamera) {
                    setSelectedCamera(cameras[0].deviceId);
                }
           
        
          
                 const constraints = {
                    video: {
                        deviceId:  selectedCamera ? { exact: selectedCamera } : cameras[0].deviceId,
                        width: 275,
                        height: 275,
                    },
                };
        
                navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {
                    try {
                        // Ensure the videoRef exists
                        if (videoRef.current) {
                          // Set the stream to the video element
                          videoRef.current.srcObject = stream;
                
                          // Attempt to play the video
                          videoRef.current.play().catch(playError => {
                            console.error("Video play failed: ", playError);
                          });
                        }
                      } catch (error) {
                        console.error("Error setting video stream: ", error);
                      }
                    
                })
                .catch(err => {
                    console.error("Error accessing camera: ", err);
                });
        
            }
    };

    const takePicture = () => {

         // Trigger animation (e.g., blinking effect for a short period)
         setIsAnimating(true);
         setTimeout(() => {
             setIsAnimating(false);
         }, 500);

        // Play click sound
        playClickSound();

        const context = canvasRef.current.getContext('2d');
        canvasRef.current.width = 1080;
        canvasRef.current.height = 1080;
        context.drawImage(videoRef.current, 0, 0, 1080, 1080);
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());

        const dataUrl = canvasRef.current.toDataURL('image/png');
        setPreview(dataUrl);

        fetch(dataUrl)
            .then(res => res.blob())
            .then(blob => {
                const file = new File([blob], `${keyName}.png`, { type: 'image/png' });
                setImage(file);
                setImageName(file.name);

                onImageChange(file,keyName); // Notify parent component of the captured image
            });

        

       

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }

        setIsCameraOpen(false);
    };

    const retakePhoto = () => {
        setPreview(null);
        setImage(null);
        setImageName('');
        setShowOpenCameraButton(true);
        openCamera();
    };

    const removePhoto = () => {
        setPreview(null);
        setImage(null);
        setImageName('');
        onImageChange(null, keyName); // Notify parent component of the removal
    
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      };

    

    const handleButtonClick = () => {
        fileInputRef.current.click();
      };

      
    const handleCameraChange = (event) => {
        setSelectedCamera(event.target.value);
    };

 
      const openModal = () => {
        setModalOpen(true);
      };
    
      const closeModal = () => {
        setModalOpen(false);
      };

    useEffect(() => {
        if (selectedCamera) {
            openCamera();
        }
    }, [selectedCamera]);

    return (

        <tr style={{ height: 300 }}>
            <td width={"50%"}>

                <input
                    className="btn btn-info d-none"
                    name="image"
                    type="file"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                />


                <div className="p-0 mt-0 d-flex flex-row justify-content-center">
                    <div className="d-flex flex-column align-items-center mb-2">
                        {/* <h6 className="pb-2 fw-bold mb-0 mt-0">{title}</h6> */}

                        {isCameraOpen && (
                            <div className="d-flex position-relative justify-content-start h-100 rounded">
                                {preview ?
                                    <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-dark p-1 rounded">Captured Image</span>

                                    :
                                    <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-danger p-1 rounded blinking">
                                        <i class="bx bxs-camera fs-3"></i>
                                    </span>
                                }

                                <video ref={videoRef} className='rounded' style={{ width: 250, height: 250 }}></video>
                                <canvas ref={canvasRef} style={{ display: 'none' }} width="275" height="275" className='justify-content-end'></canvas>
                                <span className="text-center fs-6 p-1 m-0 card-title position-absolute bottom-0 w-100 text-white bg-dark rounded-0 rounded-bottom">
                                    Atty. {subtitle.length > 25 ? `${subtitle.slice(0, 25)}...` : subtitle}
                                </span>

                            </div>
                        )}



                        {preview && (
                            <div className={`card-img card-img-right bg-label-info  d-flex position-relative justify-content-center ${isAnimating ? 'camera-blinking' : ''}`} style={{ width: 250, height: 250 }}>
                                <div className="card w-100">
                                    <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-dark p-1 rounded">Captured Image</span>
                                    <img className="card-img-top rounded-top w-100 bg-dark" src={preview} alt="Preview" style={{ minWidth: "33%", height: 250, objectFit: "contain" }} />
                                </div>
                                <span className="text-center fs-6 p-1 m-0 card-title position-absolute bottom-0 w-100 text-white bg-dark rounded-0 rounded-bottom">
                                    Atty. {subtitle.length > 25 ? `${subtitle.slice(0, 25)}...` : subtitle}
                                </span>
                            </div>
                        )}


                        {/* {lawyerPhoto && <img src={lawyerPhoto} alt={`Lawyer`} className="rounded" height={200} width={200} />}
                    <b>{titleCaseString(lawyerFullName)}</b> */}
                    </div>
                   
                </div>
            </td>
            <td>

            <div className="col d-flex flex-column   fw-bold  text-center">
                        <small><p>This image will appear on the Acknowledgment Certificate's second page.</p>
                            <p>If you wish to update the image, you can either upload or take a picture.</p></small>

                        <div className="">


                            {isCameraOpen && cameras.length > 0 && (
                                <select className="form-control w-100" onChange={handleCameraChange} value={selectedCamera}>
                                    {cameras.map((camera) => {
                                        const cameraName = camera.label.replace(/\s?\(.*\)/, '');

                                        return (<option key={camera.deviceId} value={camera.deviceId}>
                                            {cameraName || camera.label || `Camera ${camera.deviceId}`}
                                        </option>)
                                    }
                                    )}
                                </select>
                            )}

                            <div className="btn-group w-100" role="group" >

                                <Tooltip title="Upload an Image" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                    <button type="button" className="btn btn-outline-secondary w-100" onClick={handleButtonClick}>
                                        <i class="bx bx-upload" />
                                    </button>
                                </Tooltip>

                                {!isCameraOpen && !preview && (
                                    <Tooltip title="Open Camera" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                        <button className="btn btn-outline-secondary w-100" type="button" onClick={openCamera} >
                                            <i class="bx bxs-camera" />
                                        </button>
                                    </Tooltip>
                                )}

                                {isCameraOpen && (
                                    <Tooltip title="Take a Shot" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                        <button className="btn btn-outline-secondary w-100" type="button" onClick={takePicture} >
                                            <i class="bx bx-aperture"></i>
                                        </button>
                                    </Tooltip>
                                )}





                                {preview && (
                                    <>
                                        <Tooltip title="Retake a Photo" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                            <button className="btn btn-outline-secondary  w-100 " type="button" onClick={retakePhoto} >
                                                <i class="bx bx-revision"></i>
                                            </button>
                                        </Tooltip>

                                        {(hasRemoveButton && !isFromURL) &&
                                            <Tooltip title="Delete Image" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                                <button className="btn btn-outline-secondary w-100" type="button" onClick={removePhoto} >
                                                    <i className='bx bxs-trash'></i>
                                                </button>
                                            </Tooltip>
                                        }
                                    </>
                                )}



                            </div>


                        </div>
                    </div>
            </td>
        </tr>
    );
};

export default ImageCaptureMinimal;
